export class Validity {
    constructor(
        public valid = false,
        public message: string = null,
        public required = false,
        public locked = true,
    ) {}
}

export class ValidityState extends Validity {
    constructor(
        public agent: AgentValidity = new AgentValidity(),
        public attendants: AttendantsValidity = new AttendantsValidity(),
        public customer: CustomerValidity = new CustomerValidity(),
        public productPicker: ProductPickerValidity = new ProductPickerValidity(),
        public occasion: OccasionValidity = new OccasionValidity(),
        public analysis: AnalysisValidity = new AnalysisValidity(),
        public document: DocumentValidity = new DocumentValidity(),
    ) {
        super();
    }
}

export class AgentValidity extends Validity {
    constructor(
        public mandant: Validity = new Validity(),
        public agenturNummer: Validity = new Validity(),
        public agenturName: Validity = new Validity(),
        public vorname: Validity = new Validity(),
        public nachname: Validity = new Validity(),
        public vorlageVermittlerprofil: Validity = new Validity(),
    ) {
        super();
    }
}

export class AttendantsValidity extends Validity {
    constructor(
        public creatorName: Validity = new Validity(),
        public customerName: Validity = new Validity(),
        public salesType: Validity = new Validity(),
        public consultationDates: Validity = new Validity(),
        public participantItems: ValidityMap<Validity> = {},
        public consultationDateItems: ValidityMap<Validity> = {},
    ) {
        super();
    }
}

export class CustomerValidity extends Validity {
    constructor(
        public individualSalutation: Validity = new Validity(),
        public birthdate: Validity = new Validity(),
        public firstName: Validity = new Validity(),
        public lastName: Validity = new Validity(),

        public companySalutation: Validity = new Validity(),
        public companyName: Validity = new Validity(),
        public legalForm: Validity = new Validity(),
        public contactSalutation: Validity = new Validity(),
        public contactName: Validity = new Validity(),

        public country: Validity = new Validity(),
        public zip: Validity = new Validity(),
        public city: Validity = new Validity(),
        public street: Validity = new Validity(),
        public streetNumber: Validity = new Validity(),
        public postOfficeBoxNumber: Validity = new Validity(),
    ) {
        super();
    }
}

export class ProductPickerValidity extends Validity {
    constructor() {
        super();
    }
}

export class OccasionValidity extends Validity {
    constructor(
        public eventEntries: ValidityMap<Validity> = {},
        public global: GlobalOccasionValidity = new GlobalOccasionValidity(),
    ) {
        super();
    }
}

export class GlobalOccasionValidity extends Validity {
    constructor(
        public consultationDates: ValidityMap<Validity> = {},
        public sections: ValidityMap<GlobalOccasionSectionValidity> = {},
    ) {
        super();
    }
}

export class GlobalOccasionSectionValidity extends Validity {
    constructor(public entries: ValidityMap<GlobalOccasionEntryValidity> = {}) {
        super();
    }
}

export class GlobalOccasionEntryValidity extends Validity {
    constructor(
        public priority: Validity = new Validity(),
        public consultingRequested: Validity = new Validity(),
    ) {
        super();
    }
}

export class AnalysisValidity extends Validity {
    constructor(
        public demands: ValidityMap<DemandValidity> = {},
        public divisions: ValidityMap<DivisionValidity> = {},
        public lines: ValidityMap<LineValidity> = {},
    ) {
        super();
    }
}

export class DivisionValidity extends Validity {
    constructor(
        public risk: Validity = new Validity(),
        public recommendation: RecommendationValidity = new RecommendationValidity(),
        public decision: DecisionValidity = new DecisionValidity(),
    ) {
        super();
    }
}

export class DemandValidity extends Validity {
    constructor(public description: Validity = new Validity()) {
        super();
    }
}

export class RecommendationValidity extends Validity {
    constructor(
        public description: Validity = new Validity(),
        public reason: Validity = new Validity(),
        public cancellations: ValidityMap<PriorInsuranceValidity> = {},
        public cancellationImpacts: Validity = new Validity(),
        public exemptions: ValidityMap<PriorInsuranceValidity> = {},
        public exemptionImpacts: Validity = new Validity(),
        public priorInsurances: Validity = new Validity(),
    ) {
        super();
    }
}

export class PriorInsuranceValidity extends Validity {
    constructor(
        public company: Validity = new Validity(),
        public policyNumber: Validity = new Validity(),
    ) {
        super();
    }
}

export class DecisionValidity extends Validity {
    constructor(
        public description: Validity = new Validity(),
        public reason: Validity = new Validity(),
        public isAccepted: Validity = new Validity(),
        public asRecommendedReason: Validity = new Validity(),
        public rejectReason: Validity = new Validity(),
    ) {
        super();
    }
}

export class LineValidity extends Validity {
    constructor(
        public demand: Validity = new Validity(),
        public recommendation: Validity = new Validity(),
        public decision: Validity = new Validity(),
    ) {
        super();
    }
}

export class DocumentValidity extends Validity {
    constructor(public finished: Validity = new Validity()) {
        super();
    }
}

export type ValidityMap<T extends Validity> = Record<string, T>;
